import React from "react";

import { Helmet } from "react-helmet";
import HeaderNavigation from "../../components/layout/HeaderNavigation";
import CapabilityAreasSection from "./components/CapabilityAreasSection";
import EngagementModelsSection from "./components/EngagementModelsSection";
import FinalCtaSection from "./components/FinalCtaSection";
import HeroSection from "./components/HeroSection";
import WhySpotlightSection from "./components/WhySpotlightSection";
import GroupSubNav from "../../components/layout/GroupSubNav";
import SiteFooter from "../../components/layout/SiteFooter";

const CorporateTraining = () => {
  return (
    <div>
      <Helmet>
        <title>CONSULTING PRACTICE | Utiva</title>
        <meta
          name="description"
          content="Utiva helps organisations diagnose capability gaps, design relevant learning and deliver practical workforce transformation programmes."
        />
      </Helmet>

      <HeaderNavigation />
      <GroupSubNav />
      <main>
        <HeroSection />

        <EngagementModelsSection />

        <WhySpotlightSection />

        <CapabilityAreasSection />

        <FinalCtaSection />
      </main>

      <SiteFooter />
    </div>
  );
};

export default CorporateTraining;
